import { render } from "./_Board.vue?vue&type=template&id=f00c28c6&scoped=true&lang=en"
import script from "./_Board.vue?vue&type=script&lang=js"
export * from "./_Board.vue?vue&type=script&lang=js"

import "./_Board.vue?vue&type=style&index=0&id=f00c28c6&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00c28c6"]])

export default __exports__